module.exports = __webpack_public_path__ + "img/bg_rc.1768119790257.png";